import settings from '../../../src/es6/settings'
import { searchbutton } from "../../../src/es6/searchbutton"
import $ from 'jquery'

$( document ).ready(function() {
    searchbutton('.menu1__search')
    searchbutton('.menu3__btn_search')

    if(['xs', 'sm', 'smm', 'md'].includes(settings.viewSize)) {
        document.querySelector('.searchbox').style.paddingTop = '3em'
        document.querySelector('.searchbox').style.marginBottom = '-3em'
    }
})
